<template>
  <span class="typing-indicator" role="status" aria-label="Typing">
    <i></i>
    <i></i>
    <i></i>
  </span>
</template>

<style scoped lang="scss">
.typing-indicator {
  display: inline-flex;
  gap: 0.25rem;
  padding: 0.1875rem 0;

  i {
    width: 0.375rem;
    height: 0.375rem;
    border-radius: var(--t-border-radius-half-rounded);
    background: var(--t-color-neutral-600);
    animation: typing-indicator-blink 1.2s infinite;

    &:nth-child(2) {
      animation-delay: 0.18s;
    }

    &:nth-child(3) {
      animation-delay: 0.36s;
    }
  }
}

@keyframes typing-indicator-blink {
  0%,
  60%,
  100% {
    opacity: 0.3;
  }

  30% {
    opacity: 1;
  }
}
</style>
